export default
{ name: 'fixed',
  methods:
  { fixed(n, digits=0) 
    { const p10 = Math.pow(10,digits);     
      return (Math.round(p10*n)/p10).toFixed(digits) 
    }
  }
} 